<template>
  <div class="content">
    <Header :title="'消费币充值'" />
    <div class="tab-wrap">
      <div class="tab-head">
        <div
          :class="[tabIndexShow===0?'active':'']"
          class="col-2"
          @click="tabIndexShow=0"
        >充 值
        </div>
        <div
          :class="[tabIndexShow===1?'active':'']"
          class="col-2"
          @click="tabIndexShow=1"
        >充值记录
        </div>
      </div>
      <div class="tab-body">
        <!-- 充 值 -->
        <div
          v-show="tabIndexShow===0"
          class="tab"
        >
          <div class="money-number">
            <h4>充值金额</h4>
            <div class="my-card-wrap">
              <div
                v-for="(item,index) in cardList"
                :key="index"
                class="my-card"
              >
                <div
                  :class="[index===cardIndex?'active':'']"
                  class="cards"
                  @click="getClass(item,index)"
                >{{ item.money }}元
                </div>
              </div>
            </div>
          </div>
          <div class="money-type">
            <h4>充值方式</h4>
            <div class="types">
              <!-- 其它浏览器 -->
              <nut-radiogroup v-model="paymentTypeId">
                <template v-for="item in paymentType">
                  <div
                    :key="item.id"
                    class="type-row"
                    @click="checkPaymentType(item.id)"
                  >
                    <i
                      v-show="item.id==1"
                      class="iconfont icon-weixin"
                    >&#xe659;</i>
                    <i
                      v-show="item.id==2"
                      class="iconfont icon-zhifubao"
                    >&#xe663;</i>
                    {{ item.name }}
                    <div class="type-radio">
                      <nut-radio :label="item.id" />
                    </div>
                  </div>
                </template>
              </nut-radiogroup>
            </div>
          </div>
          <div class="btn">
            <nut-button
              block
              shape="circle"
              type="light"
              @click="onPay"
            >立即充值
            </nut-button>
          </div>
        </div>
        <!-- 充值记录 -->
        <div
          v-show="tabIndexShow===1"
          class="tab"
        >
          <div class="search-wrap">
            <div class="txt-wrap">
              <input
                v-model="kw"
                class="txt-search"
                placeholder="充值时间/金额查询"
                type="text"
              >
              <div class="btn-wrap">
                <input
                  class="btn-search"
                  type="button"
                  value="搜索"
                  @click="onSearch"
                >
              </div>
            </div>
          </div>

          <div class="lists">
            <ul>
              <li class="title">
                <span>充值金额</span>
                <span>状态</span>
                <span>充值支付时间</span>
              </li>
              <li
                v-for="(item,index) in list"
                v-show="list.length>0"
                :key="index"
              >
                <span>{{ item.count }}元</span>
                <span>{{ getStates(item.payStatus) }}</span>
                <span>{{ item.createdDate }}</span>
              </li>
              <div
                v-show="list.length===0"
                class="no-data"
              >抱歉！暂无数据
              </div>
            </ul>
          </div>

          <!-- 分页 -->
          <div class="page-container">
            <van-pagination
              v-model="pageIndex"
              :items-per-page="pageSize"
              :show-page-size="3"
              :total-items="total"
              force-ellipses
              @change="pageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 支付宝跳转 -->
    <div
      ref="form"
      v-html="apply"
    >{{ apply }}
    </div>
    <!-- 底部 -->
    <Footer :active="4" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Toast } from '@nutui/nutui'
import { Pagination } from 'vant'
import { convertMoney, pay, payStatus, rechargeList, rechargePageData } from '@/api/Personal/Setting/index'
import { getWeChatCodeAuthorizeUrl } from '@/api/Account'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'
import Storage from '@/utils/storage'

Vue.use(Pagination)

export default {
  name: 'MoneyPay',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      kw: '',
      pageIndex: 1,
      pageSize: 8,
      total: 0,
      tabIndexShow: 0,

      cardList: [],
      cardIndex: 0,
      paymentType: [],

      cardId: 0,
      paymentTypeId: 1,

      valueSearch: '',
      list: [],
      openId: '',
      jumpAdress: '',
      apply: '',
      submitting: false
    }
  },
  created() {
    if (this.$route.query.bind !== 'success' && sessionStorage.getItem('bind') === '1') {
      sessionStorage.removeItem('bind')
      this.$router.go(-1)
      return false
    } else {
      this.initPage()
      this.getList()
    }
  },
  methods: {
    initPage() {
      // 页面传参
      // eslint-disable-next-line
      const { out_trade_no, method, return_url, code } = this.$route.query

      if (!this.$isEmpty(return_url)) {
        Storage.sessionSet('return_url', return_url)
      }

      if (!this.$isEmpty(code)) {
        sessionStorage.setItem('code', code)
      }

      // 支付重定向处理
      this.handleRedirect(out_trade_no, method)

      // 基本信息
      const baseInfo = Storage.localGet('userInfo')

      // 微信内无openid支付
      if (baseInfo) {
        this.openId = baseInfo.openId || ''
        const { bind } = this.$route.query
        if (this.$isWeiXin() && this.$isEmpty(this.openId)) {
          if (bind !== 'success' && sessionStorage.getItem('bind') !== '1') {
            getWeChatCodeAuthorizeUrl('/Account/GetCode').then(res => {
              if (res && res.success) {
                window.location.replace(res.data)
              } else {
                Toast.fail(res.msg)
              }
            })
          } else if (bind === 'success') {
            sessionStorage.setItem('bind', '1')
          }
        }
      }

      // 加载页面数据
      rechargePageData().then(res => {
        if (res && res.success) {
          if (res.data) {
            this.cardList = res.data.amountList
            this.cardId = this.cardList[0].id
            this.paymentType = res.data.paymentType.filter(x => {
              if (x.id === 1 && this.$isAlipay()) {
                return false
              }
              if (x.id === 2 && this.$isWeiXin()) {
                return false
              }
              return true
            })

            this.paymentTypeId = this.paymentType[0].id
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    getClass(item, index) {
      this.cardIndex = index
      this.cardId = item.id
    },
    pageChange() {
      this.getList()
    },
    onSearch() {
      this.getList()
    },
    getList() {
      const params = {
        kw: this.kw,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      rechargeList(params).then(res => {
        if (res && res.success) {
          if (res.data) {
            this.total = res.data.total
            res.data.rows.forEach(item => {
              item.createdDate = this.$formatDate(item.createdDate.slice(0, 10), '/')
            })
            this.list = res.data.rows
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },

    checkPaymentType(id) {
      this.paymentTypeId = id
    },
    getStates(i) {
      switch (i) {
        case 1:
          return '未支付'
        case 2:
          return '已支付'
        case 3:
          return '支付失败'
      }
    },
    // 立即支付
    onPay() {
      let code = ''
      if (!this.$isEmpty(sessionStorage.getItem('code'))) {
        code = sessionStorage.getItem('code')
      }
      const params = {
        amountId: this.cardId,
        paymentType: this.paymentTypeId,
        tradeType: this.$isWeiXin() ? 'JSAPI' : 'MWEB',
        code: code
      }
      if (this.submitting) {
        return false
      }
      this.submitting = true
      pay(params).then(res => {
        this.submitting = false
        if (res && res.success) {
          if (this.paymentTypeId === 1) {
            if (this.$isWeiXin()) {
              this.onBridgeReady(res.data)
            } else {
              // eslint-disable-next-line camelcase
              const { mweb_url, out_trade_no } = res.data
              // 微信浏览器支付回调页面
              // eslint-disable-next-line camelcase
              const redirect_url = `&redirect_url=${encodeURIComponent(
                // eslint-disable-next-line camelcase
                `${location.origin}/Personal/Setting/MoneyPay?out_trade_no=${out_trade_no}&method=weixin`
              )}`
              // eslint-disable-next-line camelcase
              // window.location.href = mweb_url + redirect_url

              const userAgent = window.navigator.userAgent

              if (/Android/.test(userAgent) && /Quark/.test(userAgent)) {
                // eslint-disable-next-line camelcase
                window.location.href = mweb_url
              } else {
                // eslint-disable-next-line camelcase
                window.location.href = mweb_url + redirect_url
              }
            }
          }
          if (this.paymentTypeId === 2) {
            this.apply = res.data
            this.$nextTick(() => {
              document.forms[0].submit()
            })
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },

    // 处理支付重定向
    // eslint-disable-next-line camelcase
    handleRedirect(out_trade_no, method) {
      // Toast.fail(out_trade_no + method)
      if (!this.$isEmpty(out_trade_no)) {
        payStatus(out_trade_no).then(res => {
          if (res && res.success) {
            // eslint-disable-next-line camelcase
            const { out_trade_no, payStatus } = res.data
            if (payStatus === 2) {
              this.handleJump(out_trade_no)
            }
          } else {
            Toast.fail(res.msg)
          }
        })
      }

      // if (!this.$isEmpty(out_trade_no) && method == 'weixin') {
      // } else if (!this.$isEmpty(out_trade_no) && method == 'alipay.trade.wap.pay.return') {
      // }
    },
    // 支付完成后跳转处理
    // eslint-disable-next-line camelcase
    handleJump(out_trade_no) {
      // 是否存在内部跳转页面？
      // 【不存在】 跳转至 成功提示页面
      // 【存在】   提示是否兑换
      // 【兑换取消】 跳转至 跳转页面
      // 【兑换成功】 跳转至 跳转页面
      const self = this
      // eslint-disable-next-line camelcase
      const return_url = Storage.sessionGet('return_url')
      if (self.$isEmpty(return_url)) {
        self.$router.push({
          path: '/Personal/PaySuccess'
        })
        return false
      }

      this.$dialog({
        closeBtn: true,
        title: '是否立即兑换？',
        content: '是否立即将充值金额兑换成消费币？',
        okBtnTxt: '立即兑换',
        onOkBtn(event) {
          self.handleExchange(function() {
            sessionStorage.removeItem('bind')
            // eslint-disable-next-line camelcase
            window.location.href = return_url
          }, out_trade_no)
          this.close() // 关闭对话框
        },
        onCancelBtn(event) {
          sessionStorage.removeItem('bind')
          // eslint-disable-next-line camelcase
          window.location.href = return_url
        }
      })
    },

    // 微信js支付
    onBridgeReady(d) {
      const _this = this
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: d.appid,
          timeStamp: d.timeStamp,
          nonceStr: d.nonce_str,
          package: d.package,
          signType: d.signType,
          paySign: d.paySign
        },
        function(res) {
          // eslint-disable-next-line eqeqeq
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            _this.handleRedirect(d.out_trade_no, 'weixinjs')
            // eslint-disable-next-line eqeqeq
          } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
            // _this.$router.push({
            //   path: `${location.origin}/Personal/Setting/MoneyPay`,
            //   query: {
            //     rd: new Date().getTime(),
            //     bind: 'success'
            //   }
            // })
            window.location.herf = `${location.origin}/Personal/Setting/MoneyPay?rd=${new Date().getTime()}&bind=success`
            // eslint-disable-next-line eqeqeq
          } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
            _this.$router.push({
              path: '/Personal/PayFail'
            })
          } else {
            Toast.fail(res.err_msg)
          }
        }
      )
    },

    // 兑换
    // eslint-disable-next-line camelcase
    handleExchange(succ, out_trade_no) {
      convertMoney(out_trade_no).then(res => {
        if (res && res.success) {
          succ()
        } else {
          Toast.fail(res.msg)
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
// 分页
.van-pagination {
  margin-bottom: 30px;
  justify-content: center;

  ::v-deep .van-pagination__item {
    color: #555;
    border-radius: 5px;
    margin: 0 3px;
    font-weight: bold;
    height: 35px;
  }

  ::v-deep .van-pagination__item::after {
    display: none;
  }

  ::v-deep .van-pagination__item:disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item:active {
    background-color: $primary-color-bright;
    color: #fff;
  }

  ::v-deep .van-pagination__item--disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item--active {
    background-color: #fff;
    color: $primary-color;
  }

  ::v-deep .van-pagination__prev {
    max-width: 150px;
  }

  ::v-deep .van-pagination__next {
    max-width: 150px;
  }
}

//立即支付
::v-deep .nut-button.circle {
  background-color: #eea105;
  border-color: #eea105;
  color: #ffffff;
  font-size: 17px;
}

::v-deep .nut-radio input:checked {
  background-color: #eea105;
  border-color: #eea105;
}

.content {
  width: 100vw;
  min-height: 0;
  height: auto;
  overflow: hidden;
  padding: 18px 0 80px 0;

  .tab-head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;

    .col-2 {
      width: 50%;
      height: 40px;
      float: left;
      position: relative;
      text-align: center;
      box-sizing: border-box;
      color: #4d4d4d;
      border-bottom: 2px solid #cccccc;
      font-size: 16px;
      font-weight: 600;

      &.active {
        color: #eea105;
        border-bottom: 2px solid #eea105;
      }
    }
  }

  .tab-body {
    width: 100%;
    min-height: 0;
    height: auto;
    overflow: hidden;
    padding: 18px;
    box-sizing: border-box;

    .tab {
      width: 100%;
      min-height: 0;
      height: auto;
      overflow: hidden;
      position: relative;

      .money-number {
        width: 100%;
        min-height: 0;
        height: auto;
        overflow: hidden;
        position: relative;

        .my-card-wrap {
          width: 100%;
          min-height: 0;
          height: auto;
          overflow: hidden;
          text-align: center;
          font-weight: 600;

          .my-card {
            width: 33.3333333%;
            float: left;
            height: 60px;
            display: flex;
            justify-content: center;

            .cards {
              width: 90%;
              height: 50px;
              background: #ffffff;
              border-radius: 3px;
              height: 50px;
              line-height: 50px;
              color: #333333;
              float: left;
            }

            .cards.active {
              background: #eea105;
              color: #ffffff;
            }
          }
        }
      }

      .money-type {
        .types {
          position: relative;
          font-size: 16px;

          .type-row {
            width: 100%;
            height: 40px;
            line-height: 40px;
            padding: 0 0 0 30px;
            box-sizing: border-box;
            position: relative;

            .type-radio {
              position: absolute;
              right: 0;
              top: 0;
            }

            .icon-zhifubao {
              color: #07a2fe;
              position: absolute;
              left: 0;
              top: 0;
              font-size: 16px;
            }

            .icon-weixin {
              color: #09cb1f;
              position: absolute;
              left: 0;
              top: 0;
              font-size: 16px;
            }
          }
        }
      }

      .btn {
        width: 100%;
        box-sizing: border-box;
        padding: 0 18px;
        margin-top: 50px;
      }

      .search-wrap {
        width: 100%;
        height: 60px;
        position: relative;
        box-sizing: border-box;

        .txt-wrap {
          width: 100%;
          position: relative;
          box-sizing: border-box;
          padding-right: 90px;

          input {
            width: 100%;
            height: 40px;
            background: #ffffff;
            border: none;
            color: #4c4c4c;
            outline: none;
            border-radius: 5px;
            -webkit-appearance: none;
            appearance: none;
            font-size: 14px;
            box-sizing: border-box;
            padding: 0 10px;
          }

          .btn-wrap {
            width: 80px;
            height: 40px;
            position: absolute;
            right: 0;
            top: 0;

            input {
              width: 100%;
              height: 40px;
              background: #eea105;
              border: none;
              color: #ffffff;
              outline: none;
              border-radius: 5px;
              -webkit-appearance: none;
              appearance: none;
              font-size: 14px;
              text-align: center;
            }
          }
        }
      }

      .lists {
        width: 100%;
        min-height: 50px;
        height: auto;
        overflow: hidden;
        background: #ffffff;
        border-radius: 5px;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 0 0 10px 0;

        ul {
          display: block;
          width: 100%;
          height: 100%;

          li {
            span {
              display: block;
              width: 33.333333%;
              float: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 12px;
              color: #bcbcbc;
              text-align: center;
              line-height: 40px;
              height: 40px;
              padding: 0 5px;
              box-sizing: border-box;
            }
          }

          .title {
            width: 100%;
            height: 50px;
            border-bottom: 1px solid #f7f7f7;

            span {
              font-weight: 600;
              color: #4d4d4d;
              line-height: 50px;
            }
          }

          .no-data {
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            color: #999999;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
